import { AddSBeamControl } from "../subcontrol/AddSBeamControl";
import { AddSColumnControl } from "../subcontrol/AddSColumnControl";
import { AddSBarControl } from "../subcontrol/AddSBarControl";
import { AddSBraceControl } from "../subcontrol/AddSBraceControl";
import { AddSWallControl } from "../subcontrol/AddSWallControl";
import { AddSFloorControl } from "../subcontrol/AddSFloorControl";
import { AddSGridPointControl } from "../subcontrol/AddSGridPointControl";

/**
 * 结构专业的二级控制器
 */
export const STRUCTURE_SUB_CONTROL = {

    ADDSBEAMCONTROL: { name: "ADDSBEAMCONTROL", needInit: true, cmd: "AddSBeamControl", clazz: AddSBeamControl },
    ADDSCOLUMNCONTROL: { name: "ADDSCOLUMNCONTROL", needInit: true, cmd: "AddSColumnControl", clazz: AddSColumnControl },
    ADDSBARCONTROL: { name: "ADDSBARCONTROL", needInit: true, cmd: "AddSBarControl", clazz: AddSBarControl },
    ADDSBRACECONTROL: { name: "ADDSBRACECONTROL", needInit: true, cmd: "AddSBraceControl", clazz: AddSBraceControl },
    ADDSWALLCONTROL: { name: "ADDSWALLCONTROL", needInit: true, cmd: "AddSWallControl", clazz: AddSWallControl },
    ADDSFLOORCONTROL: { name: "ADDSFLOORCONTROL", needInit: true, cmd: "AddSFloorControl", clazz: AddSFloorControl },
    ADDSGRIDPOINTCONTROL: { name: "ADDSGRIDPOINTCONTROL", needInit: true, cmd: "AddSGridPointControl", clazz: AddSGridPointControl },
}